import React, { FC } from 'react';
import AuthPage from './AuthPage';

const Login: FC = () => <AuthPage initialScreen="login" />;

export default Login;
